import { useEffect } from "react";
import "@n8n/chat/style.css";
import { createChat } from "@n8n/chat";

export const ChatWidget = () => {
  useEffect(() => {
    const chat = createChat({
      webhookUrl: "https://iasgaransari.app.n8n.cloud/webhook/65cf5da5-4422-40d3-aee5-5d878b54eae2/chat",
    });

    // Cleanup: unmount hone par widget hata do (duplicate se bachne ke liye)
    return () => {
      chat?.unmount?.();
    };
  }, []);

  return null; // widget apna UI khud inject karta hai
};